export default "__VITE_ASSET__CVuxPZuZ__"